import React, {useEffect} from 'react';
import {Navigate, useLocation} from 'react-router-dom';
import {useBoundStore} from '../../Store/store';
import {Error403} from '../Errors/Error403';

/**
 * Route-level rolcheck. Als de ingelogde user's `type` niet in `allow` staat,
 * tonen we de 403-pagina in plaats van doorroute naar de kinderen. Zonder
 * user of accessToken → naar de login. Een half-geladen sessie (bv. token
 * in localStorage maar `getMe()` heeft nooit een user gehydrateerd) wordt
 * opgeruimd via logOut zodat een volgende keer geen stale flags overblijven.
 */
const RoleGuard = ({allow, children}) => {
    const user = useBoundStore(state => state.user);
    const accessToken = useBoundStore(state => state.accessToken);
    const logOut = useBoundStore(state => state.logOut);
    const location = useLocation();
    const shouldRedirect = !user?.id || !accessToken;

    useEffect(() => {
        if (shouldRedirect) {
            logOut();
        }
    }, [shouldRedirect, logOut]);

    if (shouldRedirect) {
        return <Navigate to="/" state={{from: location}} replace/>;
    }

    if (!allow.includes(user.type)) {
        return <Error403/>;
    }

    return children;
};

export default RoleGuard;
